import React from 'react'
import css from './Navbar.css'
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  }
  return (
    <header className="top-header">
      {/* LEFT */}
      <div className="left-section">
        <img
          src="./assest/logoBBT.png"
          alt="Blueberry Travel"
          className="logo"
        />
        {/* <span className="menu-icon">&#9776;</span> */}
      </div>

      {/* RIGHT */}
      <div className="right-section">
        <div
          className="profile-icon"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
          title="Logout"
        >
          <img src="./assest/Images/logout.png" alt="Logout" />
        </div>
      </div>
    </header>
  )
}

export default Navbar